import type { Notification } from '@/types/alerts'

export interface AlertsState {
  notifications: Notification[]
}

export enum ALERTS_MUTATIONS {
  SET_NOTIFICATIONS = 'setNotifications',
  ADD_NOTIFICATION = 'addNotification'
}

export enum ALERTS_ACTIONS {
  SET_NOTIFICATIONS = 'setNotifications',
  ADD_NOTIFICATION = 'addNotification'
}

export enum ALERTS_GETTERS {
  GET_NOTIFICATIONS = 'getNotifications',
  GET_NOTIFICATIONS_NUM = 'getNotificationsNum',
  GET_NOTIFICATIONS_BY_DEVICE_ID = 'getNotificationsByDeviceId',
  GET_NOTIFICATIONS_NUM_BY_DEVICE_ID = 'getNotificationsNumByDeviceId'
}
